import React from 'react';

function ErrorModal({ error, onClose }) {
  if (!error) return null;

  return (
    <div className="search-popup-overlay" onClick={onClose}>
      <div className="search-popup datatrace-modal" onClick={(e) => e.stopPropagation()}>
        <div className="search-popup-header" style={{ backgroundColor: '#dc3545', color: 'white' }}>
          <h3>⚠ Property Verification Error</h3>
          <button className="search-popup-close" onClick={onClose} style={{ color: 'white' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div className="search-popup-content datatrace-modal-content">
          <div style={{ marginBottom: '15px' }}>
            <strong style={{ fontSize: '16px', color: '#dc3545' }}>{error.message}</strong>
            <p style={{ marginTop: '10px', color: '#666' }}>{error.details}</p>
            {error.timestamp && (
              <p style={{ fontSize: '12px', color: '#999', marginTop: '10px' }}>
                {new Date(error.timestamp).toLocaleString()}
              </p>
            )}
          </div>

          {/* Show suggestions for NotAvailable errors */}
          {error.errorType === 'NotAvailable' && error.suggestions && (
            <div style={{
              backgroundColor: '#fff3cd',
              border: '1px solid #ffc107',
              borderRadius: '4px',
              padding: '15px',
              marginBottom: '15px'
            }}>
              <h4 style={{ margin: '0 0 10px 0', color: '#856404', fontSize: '14px' }}>💡 Suggestions:</h4>
              <ul style={{ margin: 0, paddingLeft: '20px', color: '#856404' }}>
                {error.suggestions.map((suggestion, index) => (
                  <li key={index} style={{ marginBottom: '5px' }}>{suggestion}</li>
                ))}
              </ul>
              {error.transactionId && (
                <p style={{ marginTop: '10px', fontSize: '12px', color: '#856404' }}>
                  Transaction ID: {error.transactionId}
                </p>
              )}
            </div>
          )}

          <div className="datatrace-modal-actions">
            <button
              className="copy-json-button"
              onClick={() => {
                const errorText = JSON.stringify(error, null, 2);
                navigator.clipboard.writeText(errorText);
                alert('Error details copied to clipboard!');
              }}
            >
              📋 Copy Error Details
            </button>
          </div>
          <pre className="datatrace-json-display" style={{ maxHeight: '400px', overflow: 'auto' }}>
            {JSON.stringify(error, null, 2)}
          </pre>
        </div>
      </div>
    </div>
  );
}

export default ErrorModal;
